$(function(){

  const formatMoney = (price) => {
    try { return skyFormatPriceDisplay(parseFloat(price).toFixed(2)); } catch(e){ return "$0.00" }
  };
  const formatDate = (ts) => northSkyformatDate(ts, -5);
  const defaultPageSize = 50;
  const STORAGE_KEY = 'bulk-order-state';
  const createBlankRow = (line, zip) => ({
    id: `${Date.now()}_${Math.random()}`,
    line,
    modelInput: '',
    suggestions: [],
    suggestionsVisible: false,
    product: null,
    quantity: 1,
    zip: zip || '',
    zipValid: false,
    zipError: '',
    error: '',
    eta: { loading: false,deliveryTimeStr: "", zipIsOpen: true },
    timers: { eta: null, suggest: null }
  });
  new Vue({
    el: '#bulk-order-app',
    delimiters: ['${', '}'],
    data(){
      return {
        step: 1,
        rows: [],
        currentPage: 1,
        pageSize: defaultPageSize,
        pasteInput: '',
        pasteErrors: [],
        notFoundErrors: [],
        quoteForm: { firstName:'', lastName:'', phone:'', companyName:'', message:'' },
        quoteRules: {},
        quoteLoading: false,
        quoteError: '',
        quoteSuccess: false,
        defaultZip: '',
        persist: null,
        mobileSearch: { visible:false, keyword:'', results:[], rowId:'', loading:false, timer:null, _lastQuery:'', page:0, size:20, hasMore:false },
        mobilePasteVisible: false,
        searchCache: {},
        etaQueue: [],
        etaRunning: 0,
        etaMaxConcurrent: 3,
        etaInFlight: {},
        allLoading: false,
        suppressQuery: false,
        queryCooldownUntil: 0
      }
    },
    computed: {
      pagedRows(){
        const start = (this.currentPage-1)*this.pageSize;
        return this.rows.slice(start, start+this.pageSize);
      },
      totalPages(){
        return Math.max(1, Math.ceil(this.rows.length/this.pageSize));
      },
      pagesArray(){
        const t = this.totalPages; const arr=[]; for(let i=1;i<=t;i++){ arr.push(i); } return arr;
      }
    },
    created(){
      $('.js-bulk-order-app').removeClass('hidden');
      $('.js-bulk-order-skeleton').addClass('hidden');
      {
        const existingZip = (window.northsky && window.northsky.customerZipCode) || localStorage.getItem('customerZipCode') || '';
        if (existingZip) {
          this.defaultZip = String(existingZip);
        } else {
          try {
            getLocalZipCode((value) => { this.defaultZip = value || ''; });
          } catch (error) {}
        }
      }
      this.persist = throttleNew(() => this.saveStateNow(), 300, this, false);
      const saved = this.loadState();
      if (saved && Array.isArray(saved.rows) && saved.rows.length>0) {
        this.rows = saved.rows.map((r, idx)=>{
          const row = createBlankRow(idx+1, r.zip || this.defaultZip);
          row.id = r.id || `${Date.now()}_${Math.random()}`;
          row.line = r.line || idx+1;
          row.modelInput = r.modelInput || '';
          row.product = r.product ? Object.assign({}, r.product) : null;
          row.quantity = r.quantity || 1;
          row.zipValid = !!r.zipValid;
          row.zip = r.zip || '';
          row.eta.deliveryTimeStr = r.eta?.deliveryTimeStr || "";
          row.eta.zipIsOpen = r.eta?.deliveryTimeStr ? false : true
          return row;
        });
        this.currentPage = saved.currentPage || 1;
      } else {
        for(let i=1;i<=5;i++){ this.rows.push(createBlankRow(i, '')); }
      }
      this.quoteRules = {
        firstName: [{ required: true, message: 'First Name is required', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Last Name is required', trigger: 'blur' }],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' },
          { validator: this.validatePhoneNumber, trigger: 'blur' }
        ],
        companyName: [],
        message: []
      };
    },
    mounted(){
    },
    methods: {
      formatMoney,
      formatDate,
      ensureRowZip(row){
        if (row.zip) return;
        const idx = this.rows.findIndex(r=> r.id === row.id);
        row.zip = idx === 0 ? (this.defaultZip || '') : ((this.rows[idx-1] && this.rows[idx-1].zip) ? this.rows[idx-1].zip : '');
      },
      setQuantity(row, qty){
        const max = 1000000;
        const min = 1;
        const next = Math.max(min, Math.min(max, qty || 1));
        row.quantity = next;
        this.scheduleEta(row);
        this.persist();
      },
      normalizeProductData(p){
        return {
          value: p.model || p.sku,
          sku: p.sku || '',
          title: p.title || '',
          brand: p.brand || '',
          model: p.model || '',
          price: p.price || 0,
          image: p.image || '',
          variantId: p.variantId || '',
          moq: p.moq || 1,
          mpq: p.mpq || 1,
          totalScore: p.totalScore || 0,
          totalReviews: p.totalReviews || 0
        };
      },
      isRowEmpty(row){
        return !row.product && !(row.modelInput||'').trim();
      },
      getPrevZipForIndex(i){
        return i>0 ? (this.rows[i-1].zip || '') : (this.defaultZip || '');
      },
      
      async searchProducts(keyword, size, from){
        const k = (keyword||'').trim();
        if (!k) return [];
        if (this.suppressQuery || Date.now() < this.queryCooldownUntil) return [];
        const s = size || 5;
        const f = from || 0;
        const cacheKey = `${k.toLowerCase()}|${s}|${f}|bulkQuery`;
        if (this.searchCache[cacheKey]) return this.searchCache[cacheKey];
        const payload = { models: [{ model: k }], customerId: window.northsky.customerId || '' };
        try {
          const res = await kkAjax.post('/openapi/bulk/order/query', payload);
          const infos = res?.data || [];
          const list = (infos||[]).map(p=> this.normalizeProductData(p));
          this.searchCache[cacheKey] = list;
          return list;
        } catch(e){ return []; }
      },
      addLine(){
        const nextLine = this.rows.length+1;
        // this.rows.push(createBlankRow(nextLine, this.getPrevZipForIndex(this.rows.length) || this.defaultZip || ''));
        this.rows.push(createBlankRow(nextLine, ''));
        this.currentPage = this.totalPages;
        this.persist();
      },
      removeRow(row){
        this.rows = this.rows.filter(r=>r.id!==row.id).map((r,idx)=>{ r.line = idx+1; return r; });
        if (this.currentPage>this.totalPages) this.currentPage = this.totalPages;
        this.persist();
      },
      removeRowByIndex(idx){
        const start = (this.currentPage - 1) * this.pageSize;
        const actual = start + idx;
        if (actual < 0 || actual >= this.rows.length) return;
        this.rows.splice(actual, 1);
        this.rows = this.rows.map((r, i) => { r.line = i + 1; return r; });
        if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
        this.persist();
      },
      removeRowById(id){
        const idx = this.rows.findIndex(r => r.id == id);
        if (idx == -1) return;
        this.rows.splice(idx, 1);
        this.rows = this.rows.map((r, i) => { r.line = i + 1; return r; });
        if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
        this.persist();
      },
      debouncedFetchSuggestions(row){
        if (row.timers.suggest) clearTimeout(row.timers.suggest);
        row.timers.suggest = setTimeout(()=>{ this.fetchSuggestions(row); }, 300);
      },
      remoteSearch(queryString, cb, row){
        if (this.suppressQuery || Date.now() < this.queryCooldownUntil) { cb([]); return; }
        const keyword = (queryString || '').trim().slice(0,50);
        if (!keyword || keyword.length<2) { cb([]); return; }
        row._lastQuery = keyword;
        this.searchProducts(keyword, 5, 0).then(list=>{
          if (row._lastQuery !== keyword) return;
          if (list && list.length) cb(list); else cb([{ noResult:true, model:'', title:'No results' }]);
        }).catch(()=>cb([]));
      },
      async fetchSuggestions(row){
        if (this.suppressQuery || Date.now() < this.queryCooldownUntil) return;
        const keyword = (row.modelInput||'').trim().slice(0,50);
        row.suggestionsVisible = false;
        row.suggestions = [];
        row.error = '';
        if (!keyword || keyword.length<2) return;
        try {
          const list = await this.searchProducts(keyword, 5, 0);
          row.suggestions = (list && list.length) ? list : [{ noResult:true, model:'', title:'No results' }];
          row.suggestionsVisible = true;
        } catch(e) { row.error = 'Search failed'; }
      },
      onSelectSuggestion(row, item){
        if (item && item.noResult) return;
        const normalized = Object.assign({}, item);
        normalized.sku = item.sku || item.value;
        normalized.image = item.image || ''
        row.product = normalized;
        row.modelInput = (normalized.model || normalized.value).slice(0,50);
        row.quantity = 1;
        row.eta.zipIsOpen = true;
        this.ensureRowZip(row);
        let didValidateZip = false;
        if (row.zip && /^\d{5}$/.test(row.zip) && !row.zipValid) {
          this.onZipEntered(row);
          didValidateZip = true;
        }
        row.error = '';
        row.skipBlurValidation = true;
        if (!didValidateZip && row.zipValid && row.product?.sku) this.scheduleEta(row);
        this.persist();
      },
      selectSuggestion(row, item){
        if (!item || item.noResult) { row.error = 'invalid model number'; this.persist(); return; }
        row.product = Object.assign({}, item);
        row.modelInput = (item.model||'').slice(0,50);
        row.quantity = 1;
        row.eta.zipIsOpen = true;
        this.ensureRowZip(row);
        let didValidateZip = false;
        if (row.zip && /^\d{5}$/.test(row.zip) && !row.zipValid) {
          this.onZipEntered(row);
          didValidateZip = true;
        }
        row.suggestionsVisible = false;
        row.suggestions = [];
        row.error = '';
        if (!didValidateZip && row.zipValid && row.product?.sku) this.scheduleEta(row);
        this.persist();
      },
      async confirmModel(row){
        const input = (row.modelInput||'').trim().slice(0,50);
        if (!input) { row.product=null; return; }
        if (row.skipBlurValidation) { row.skipBlurValidation = false; row.error=''; return; }
        const norm = v => String(v||'').trim().toLowerCase();
        if (row.product && norm(row.product.model)==norm(input)) return;
        await this.fetchSuggestions(row);
        const exact = row.suggestions.find(s=> norm(s.model)==norm(input) || norm(s.sku)==norm(input));
        if (exact) { this.selectSuggestion(row, exact); }
        else if (row.suggestions.length==1 && !row.suggestions[0].noResult) { this.selectSuggestion(row, row.suggestions[0]); }
        else { row.error = 'invalid model number'; this.persist(); }
      },
      increaseQty(row){
        this.setQuantity(row, (row.quantity||1)+1);
      },
      decreaseQty(row){
        this.setQuantity(row, (row.quantity||1)-1);
      },
      onQtyChanged(row){
        this.setQuantity(row, row.quantity);
      },
      onZipInput(row){
        const v = (row.zip||'').trim();
        if (v.length==5 && !isNaN(v)) { this.onZipEntered(row); }
      },
      async onZipEntered(row){
        const v = (row.zip||'').trim();
        row.zipError='';
        row.zipValid=false;
        if (!v) { row.zipError='ZIP Code is required'; return; }
        if (!/^\d{5}$/.test(v)) { row.zipError='ZIP Code must be 5 digits'; return; }
        try {
          const zipResult = await new Promise((resolve, reject)=>{ getZipCode('US', v, function(result){ result?.valid?resolve(result):reject(new Error('Invalid ZIP code')); }); });
          const admin = zipResult?.zipcodeDetails?.adminName1 || zipResult?.lookup?.adminName1 || '';
          row.zipValid = true;
          row.zipAdminName1 = admin;
          if (row.product?.sku) this.scheduleEta(row, true);
          this.persist();
        } catch(e){ row.zipError='Invalid ZIP code'; this.persist(); }
      },
      changeZipStatus(row){
        row.eta.zipIsOpen = !row.eta.zipIsOpen
      },
      openMobileSearch(row){
        this.mobileSearch.visible = true;
        this.mobileSearch.rowId = row.id;
        this.mobileSearch.keyword = (row.modelInput || '').slice(0,50);
        this.mobileSearch.results = [];
        this.mobileSearch.page = 0;
        this.mobileSearch.hasMore = false;
        if ((this.mobileSearch.keyword||'').trim()) this.performMobileSearch();
      },
      closeMobileSearch(){
        this.mobileSearch.visible = false;
        this.mobileSearch.keyword = '';
        this.mobileSearch.results = [];
        this.mobileSearch.rowId = '';
        this.mobileSearch.loading = false;
        if (this.mobileSearch.timer) { clearTimeout(this.mobileSearch.timer); this.mobileSearch.timer=null; }
        this.mobileSearch._lastQuery = '';
        this.mobileSearch.page = 0;
        this.mobileSearch.hasMore = false;
      },
      performMobileSearchDebounced(){
        const keyword = (this.mobileSearch.keyword||'').trim().slice(0,50);
        if (this.mobileSearch.timer) clearTimeout(this.mobileSearch.timer);
        if (!keyword) { this.mobileSearch.results=[]; this.mobileSearch.loading=false; this.mobileSearch.hasMore=false; return; }
        this.mobileSearch._lastQuery = keyword;
        this.mobileSearch.timer = setTimeout(()=>{
          this.mobileSearch.loading = true;
          this.mobileSearch.page = 0;
          this.searchProducts(keyword, this.mobileSearch.size, 0).then(list=>{
            if (this.mobileSearch._lastQuery !== keyword) return;
            this.mobileSearch.results = list;
            this.mobileSearch.hasMore = list.length === this.mobileSearch.size;
            this.mobileSearch.loading = false;
          }).catch(()=>{
            if (this.mobileSearch._lastQuery !== keyword) return;
            this.mobileSearch.results = [];
            this.mobileSearch.hasMore = false;
            this.mobileSearch.loading = false;
          });
        }, 300);
      },
      performMobileSearch(){
        const keyword = (this.mobileSearch.keyword||'').trim().slice(0,50);
        if (!keyword) { this.mobileSearch.results=[]; return; }
        this.mobileSearch._lastQuery = keyword;
        this.mobileSearch.loading = true;
        this.mobileSearch.page = 0;
        this.searchProducts(keyword, this.mobileSearch.size, 0).then(list=>{
          if (this.mobileSearch._lastQuery !== keyword) return;
          this.mobileSearch.results=list;
          this.mobileSearch.hasMore = list.length === this.mobileSearch.size;
          this.mobileSearch.loading=false;
        }).catch(()=>{
          if (this.mobileSearch._lastQuery !== keyword) return;
          this.mobileSearch.results=[];
          this.mobileSearch.hasMore = false;
          this.mobileSearch.loading=false;
        });
      },
      loadMoreMobileSearch(){
        const keyword = (this.mobileSearch.keyword||'').trim();
        if (!keyword || this.mobileSearch.loading || !this.mobileSearch.hasMore) return;
        const nextPage = this.mobileSearch.page + 1;
        const from = nextPage * this.mobileSearch.size;
        this.mobileSearch.loading = true;
        this.searchProducts(keyword, this.mobileSearch.size, from).then(list=>{
          if (this.mobileSearch._lastQuery !== keyword) return;
          this.mobileSearch.results = this.mobileSearch.results.concat(list);
          this.mobileSearch.page = nextPage;
          this.mobileSearch.hasMore = list.length === this.mobileSearch.size;
          this.mobileSearch.loading = false;
        }).catch(()=>{
          if (this.mobileSearch._lastQuery !== keyword) return;
          this.mobileSearch.loading = false;
        });
      },
      selectMobileResult(item){
        const idx = this.rows.findIndex(r=> r.id === this.mobileSearch.rowId);
        if (idx !== -1) { this.onSelectSuggestion(this.rows[idx], item); }
        this.closeMobileSearch();
      },
      scheduleEta(row, immediate=false){
        if (!row.zipValid || !row.product?.sku) return;
        if (row.timers.eta) clearTimeout(row.timers.eta);
        const wait = immediate?0:2000;
        row.timers.eta = setTimeout(()=>{ this.enqueueEta(row); }, wait);
      },
      enqueueEta(row){
        const key = `${row.zip}|${row.product?.sku}|${row.quantity}`;
        if (this.etaInFlight[key]) return;
        if (this.etaQueue.find(e=>e.key===key)) return;
        this.etaQueue.push({ row, key });
        this.runEtaQueue();
      },
      runEtaQueue(){
        if (this.etaRunning > 0 || this.etaQueue.length === 0) return;
        const batch = this.etaQueue.splice(0, this.etaQueue.length);
        this.etaRunning = 1;
        batch.forEach(e=>{ this.etaInFlight[e.key] = true; });
        const rows = batch.map(e=>e.row);
        this.fetchEtaBatch(rows).finally(()=>{
          this.etaRunning = 0;
          batch.forEach(e=>{ delete this.etaInFlight[e.key]; });
          this.runEtaQueue();
        });
      },
      async fetchEtaBatch(rows){
        if (!Array.isArray(rows) || rows.length === 0) return;
        const ready = [];
        for (const r of rows) {
          if (!r.zipValid || !r.product?.sku) continue;
          r.eta.loading = true;
          let adminName1 = r.zipAdminName1 || '';
          if (!adminName1) {
            try {
              const zipResult = await new Promise((resolve, reject)=>{ getZipCode('US', r.zip, function(result){ result?.valid?resolve(result):reject(new Error('Invalid ZIP code')); }); });
              adminName1 = zipResult?.zipcodeDetails?.adminName1 || zipResult?.lookup?.adminName1 || '';
              r.zipAdminName1 = adminName1;
            } catch(e) {
              r.eta.loading = false;
              continue;
            }
          }
          ready.push({ MATNR: r.product.sku, ZQTY: r.quantity, Z002: 'US', Z004: adminName1 || '', POST_CODE2: r.zip, __row: r });
        }
        if (!ready.length) return;
        try {
          const deliveryParams = ready.map(x=>({ MATNR: x.MATNR, ZQTY: x.ZQTY, Z002: x.Z002, Z004: x.Z004, POST_CODE2: x.POST_CODE2 }));
          const res = await kkAjax.post('/openapi/adlink/delivery-calculation/batch', { checkoutToken: null, deliveryCalculationParam: deliveryParams });
          const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
          const map = {};
          for (const it of list) {
            const key = it?.sku || it?.MATNR || it?.matnr || '';
            if (key) map[String(key)] = it;
          }
          for (const x of ready) {
            const r = x.__row;
            const m = map[String(x.MATNR)] || null;
            const str = m ? buildDeliveryTimeElement(m) : (m.deliveryTimeStr || '');
            r.eta.loading = false;
            r.eta.deliveryTimeStr = str || '';
            if (str) r.eta.zipIsOpen = false;
          }
          this.persist();
        } catch(e) {
          for (const x of ready) { x.__row.eta.loading = false; }
        }
      },
      async submitPaste(){
        this.pasteErrors = [];
        this.notFoundErrors = [];
        this.suppressQuery = true;
        const invalids = new Set();
        const notFoundSet = new Set();
        const _rawPaste = (this.pasteInput||'');
        const _limitedPaste = _rawPaste.length > 15000 ? _rawPaste.slice(0,15000) : _rawPaste;
        const lines = _limitedPaste.split(/\n|\r/).map(l=>l.trim()).filter(l=>l);
        if (!lines.length) return;
        const requests = [];
        const rawLines = [];
        for (const line of lines) {
          const m = line.split(',').map(s=>s.trim());
          rawLines.push(line);
          if (m.length!==2) { invalids.add(line); continue; }
          const model = m[0];
          const qtyStr = m[1];
          if (!model || !/^\d+$/.test(qtyStr)) { invalids.add(line); continue; }
          const qty = Number(qtyStr);
          if (qty<=0) { invalids.add(line); continue; }
          requests.push({ model, quantity: Math.min(10000000, qty), raw: line });
        }
        if (!requests.length) { this.pasteErrors = Array.from(invalids); return; }
        const normModel = v=> String(v||'').trim().toLowerCase();
        const dedupeMap = new Map();
        for (let i=0;i<requests.length;i++){
          const r = requests[i];
          const key = normModel(r.model);
          if (!key) continue;
          if (!dedupeMap.has(key)) dedupeMap.set(key, { model: r.model, quantity: r.quantity, raw: r.raw });
          else { const prev = dedupeMap.get(key); prev.quantity = Math.min(10000000, (prev.quantity||0) + r.quantity); }
        }
        const dedupedRequests = Array.from(dedupeMap.values()).map(x=>({ model: x.model, quantity: x.quantity }));
        const dedupedRawLines = Array.from(dedupeMap.values()).map(x=> x.raw);
        const MAX_LINES = 100;
        const limitedCount = Math.min(MAX_LINES, dedupedRequests.length);
        const limitedRequests = dedupedRequests.slice(0, limitedCount);
        const limitedRawLines = dedupedRawLines.slice(0, limitedCount);
        try {
          if(this.allLoading) return;
          this.allLoading = true;
          const res = await kkAjax.post('/openapi/bulk/order/query', { models: limitedRequests });
          this.allLoading = false;
          const infos = res?.data || [];
          const mapByModel = {};
          for (const p of infos) {
            const key1 = normModel(p.model);
            const key2 = normModel(p.sku || p.variantSku);
            if (key1) mapByModel[key1] = p;
            if (key2) mapByModel[key2] = p;
          }
          const items = limitedRequests.map((req, idx)=>({ req, raw: limitedRawLines[idx], p: mapByModel[normModel(req.model)] }));
          for (const it of items) { if (!it.p) notFoundSet.add(it.raw); }
          this.notFoundErrors = Array.from(notFoundSet);
          this.pasteErrors = Array.from(invalids);
          const matched = items.filter(it=> !!it.p);
          const scheduled = [];
          let mi = 0;
          for (let i=0; i<this.rows.length && mi<matched.length; i++) {
            const row = this.rows[i];
            if (!this.isRowEmpty(row)) continue;
            const it = matched[mi++];
            row.modelInput = it.req.model;
            row.quantity = it.req.quantity;
            row.product = this.normalizeProductData(it.p);
            row.error = '';
            if (!row.zip) row.zip = this.getPrevZipForIndex(i) || '';
            scheduled.push(row);
          }
          const toAdd = [];
          for (; mi<matched.length; mi++) {
            const it = matched[mi];
            const nr = createBlankRow(this.rows.length+toAdd.length+1, '');
            nr.modelInput = it.req.model;
            nr.quantity = it.req.quantity;
            nr.product = this.normalizeProductData(it.p);
            nr.error = '';
            const prevZip = toAdd.length>0 ? (toAdd[toAdd.length-1].zip || '') : (this.rows.length ? (this.rows[this.rows.length-1].zip || '') : (this.defaultZip || ''));
            if (!nr.zip) nr.zip = prevZip || '';
            toAdd.push(nr);
          }
          if (toAdd.length) this.rows.push(...toAdd);
          this.currentPage = this.totalPages;
          scheduled.concat(toAdd).forEach(r=>{ r.suggestionsVisible=false; r.suggestions=[]; });
          await this.runPasteEta(scheduled.concat(toAdd));
          
          this.persist();
          const addedCount = scheduled.filter(r=>!!r.product).length + toAdd.filter(r=>!!r.product).length;
          if (addedCount > 0) {
            this.pasteInput = '';
            if(this.mobilePasteVisible) {
              this.mobilePasteVisible = false
            }
            this.$message({ showClose: true, message: 'Submit succeeded', type: 'success' });
          }
        } catch(e) {
          this.allLoading = false;
          this.pasteErrors = Array.from(invalids).length ? Array.from(invalids) : limitedRawLines;
          this.notFoundErrors = Array.from(notFoundSet);
          this.$message({ showClose: true, message: e.message || 'failed', type: 'warning' });
        } finally { this.suppressQuery = false; this.queryCooldownUntil = Date.now() + 3000; }
      },
      async runPasteEta(rows){
        const list = Array.isArray(rows) ? rows.filter(r=>r && r.product?.sku && r.zip && /^\d{5}$/.test(r.zip)) : [];
        if (!list.length) return;
        for (const r of list) { r.eta.loading = true; }
        const needZip = [];
        const zipMap = {};
        for (const r of list) {
          const z = r.zip;
          if (!zipMap[z]) zipMap[z] = { rows: [] };
          zipMap[z].rows.push(r);
          if (!r.zipValid || !r.zipAdminName1) needZip.push(z);
        }
        const uniqueNeedZip = Array.from(new Set(needZip));
        const zipPromises = uniqueNeedZip.map(z=> new Promise((resolve)=>{ getZipCode('US', z, function(result){ resolve({ zip:z, result }); }); }));
        const zipResults = await Promise.all(zipPromises);
        for (const zr of zipResults) {
          const z = zr.zip;
          const ok = zr.result?.valid;
          const admin = zr.result?.zipcodeDetails?.adminName1 || zr.result?.lookup?.adminName1 || '';
          const group = zipMap[z]?.rows || [];
          for (const r of group) {
            if (ok) { r.zipValid = true; r.zipError=''; r.zipAdminName1 = admin; }
            else { r.zipValid = false; r.zipError='Invalid ZIP code'; }
          }
        }
        const deliveryParams = [];
        for (const r of list) {
          if (!r.zipValid) continue;
          deliveryParams.push({ MATNR: r.product.sku, ZQTY: r.quantity, Z002: 'US', Z004: r.zipAdminName1 || '', POST_CODE2: r.zip });
        }
        if (!deliveryParams.length) { for (const r of list) { r.eta.loading = false; } return; }
        try {
          const res = await kkAjax.post('/openapi/adlink/delivery-calculation/batch', { checkoutToken: null, deliveryCalculationParam: deliveryParams });
          const arr = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
          const map = {};
          for (const it of arr) { const k = it?.sku || it?.MATNR || it?.matnr || ''; if (k) map[String(k)] = it; }
          for (const r of list) {
            const m = map[String(r.product.sku)] || null;
            const str = m ? buildDeliveryTimeElement(m) : (m.deliveryTimeStr || '');
            r.eta.loading = false;
            r.eta.deliveryTimeStr = str || '';
            if (str) r.eta.zipIsOpen = false;
          }
        } catch(e) {
          for (const r of list) { r.eta.loading = false; }
        }
      },
      clearPaste(){ this.pasteInput=''; this.pasteErrors=[]; this.notFoundErrors = []; },
      validRows(){
        return this.rows.filter(r=>r.product && r.quantity>=1);
      },
      async addToCart(){
        try{
            const rows = this.validRows();
            const items = [];
            for (const r of rows) {
              const info = r.product;
              const moq = info.moq||1; const mpq = info.mpq||1;
              const finalQty = mainProductUtils.validateQuantity(r.quantity, moq, mpq, 1000000);
              if (!info.variantId) continue;
              items.push({ variantId: info.variantId, quantity: finalQty });
            }
            if (items.length) {
              if(this.allLoading) return;
              this.allLoading = true;
              await cartFormModule.addToCartBulk(items);
              this.allLoading = false;
            }
         } catch(e) {
          this.allLoading = false;
         }
      },
      async proceedToOrder(){
        try {
           if(this.allLoading) return;
           this.allLoading = true;
           await this.addToCart();
           window.location.href = '/checkout';
        } catch(e) {
          this.allLoading = false;
          this.$message({
            showClose: true,
            message: e.message || 'Add to cart failed',
            type: 'warning',
          });
        }
      },
      goToQuote(){ 
        this.step=2; 
        $('html, body').animate({ scrollTop: 0 }, 'fast');
        $('html, body').addClass('fb-md:bg-F9F9F9');
      },
      goBack(){
        this.step=1;
        $('html, body').animate({ scrollTop: 0 }, 'fast');
        $('html, body').removeClass('fb-md:bg-F9F9F9');
      },
      validateQuote(){
        const f = this.quoteForm;
        if (!f.firstName) return 'First Name required';
        if (!f.lastName) return 'Last Name required';
        let phoneErr = '';
        try {
          const phone = libphonenumber.parsePhoneNumberFromString(f.phone, 'US');
          if (!phone || !phone.isValid()) phoneErr = 'Invalid phonenumber';
        } catch(e){ phoneErr = 'Invalid phonenumber'; }
        if (phoneErr) return phoneErr;
        return '';
      },
      validatePhoneNumber(rule, value, callback){
        if (!value) return callback(new Error('Phone is required'));
        try {
          const phone = libphonenumber.parsePhoneNumberFromString(value, 'US');
          if (!phone || !phone.isValid()) return callback(new Error('Invalid phonenumber'));
          return callback();
        } catch(e){ return callback(new Error('Invalid phonenumber')); }
      },
      async submitQuote(){
        this.quoteError=''; this.quoteSuccess=false;
        this.$refs.quoteFormRef && this.$refs.quoteFormRef.validate(async (valid)=>{
          if (!valid) { return; }
          this.quoteLoading=true;
          try {
            const lineDetails = this.validRows().map(r=>({ skuId: r.product.sku, model: r.product.model, title: r.product.title, quantity: r.quantity, zipCode: r.zip }));
            const payload = { firstName: this.quoteForm.firstName, lastName: this.quoteForm.lastName, phone: this.quoteForm.phone, companyName: this.quoteForm.companyName, message: this.quoteForm.message, channelCode: window.northsky?.channelCode, lineDetails };
            const res = await kkAjax.post('/openapi/save/bulk/order', payload);
            if (res && (res.code==200)) { this.quoteSuccess=true; }
            else { this.quoteError = res?.msg || 'Failed to submit'; }
          } catch(e){ this.quoteError='Failed to submit'; }
          finally { this.quoteLoading=false; }
        });
      },
      saveStateNow(){
        try {
          const rows = this.rows.map(r=>({ id:r.id, line:r.line, modelInput:r.modelInput, product: r.product ? { sku:r.product.sku, model:r.product.model, title:r.product.title, brand:r.product.brand, image:r.product.image, variantId:r.product.variantId, moq:r.product.moq, mpq:r.product.mpq } : null, quantity:r.quantity, zip:r.zip, zipValid:r.zipValid, eta:{ deliveryTimeStr: r.eta.deliveryTimeStr } }));
          const state = { rows, currentPage: this.currentPage };
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        } catch(e){}
      },
      loadState(){
        try { const raw = sessionStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; } catch(e){ return null; }
      },
      setPage(p){ this.currentPage = p; this.persist(); },
      handlePageChangeElement(page){ this.currentPage = page; this.persist(); },
      openMobilePaste(){ this.mobilePasteVisible = true; },
      closeMobilePaste(){ this.mobilePasteVisible = false; }
    }
  });
});
      
